export default __webpack_public_path__ + "static/media/new-replay.1207d48f.svg";